<form>
    <div id=noteTypeSelector class="noteTypeSelectorContainer no-print">
        <div>
            <mat-button-toggle-group name="favoriteColor" value="all" [hideSingleSelectionIndicator]="true"                 >
                <mat-button-toggle value="all" (click)='selectAll()'>All</mat-button-toggle>
                <mat-button-toggle value="none" (click)='selectNone()'>None</mat-button-toggle>
            </mat-button-toggle-group>

            <!-- <div class='btn-group no-print'>
                
                <button type='button' ng-class='allButtonStyle' ng-click='selectAll();'>All</button>
                <button type='button' ng-class='noneButtonStyle' ng-click='selectNone();'>None</button>
            </div> -->

        <div class='pull-right' *ngIf="showMemberNoteControls">
                <button mat-raised-button
                        class="secondary-button"
                        (click)='openCreateMemberNoteDialog()'>Create Note</button>
        </div>
        </div>

        <div class="noteTypeSelector">
            <span *ngFor="let option of options; index as i">
                <label >
                    <mat-checkbox   (change)='selectedValuesChanged({index:i, checked: $event.checked})' 
                                    [name]="option.name" 
                                    [value]="option.value" 
                                    [checked]="option.selected">
                        {{option.caption}}
                    </mat-checkbox>
                    <!-- <input type='checkbox' [(ngModel)]='option.selected'
                        ng-change='selectedValuesChanged()'>{{option.text}} -->
                </label> 
                <!-- ng-true-value='1' ng-false-value='0'-->
            </span> 
        </div>
    </div>
</form>
